/* @ngInject */
const pieceMetadata = (
  pieceFields
) => {
  const self = {}

  self.favoriteSort = ['name',]

  self.fields = pieceFields

  return self
}
export default pieceMetadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/services/metadata.service.js